import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Mtnz from "../components/register/mtnz";
import Mtnet from "../components/register/mtnet";
import Mtnlb from "../components/register/mtnlb";
import { service } from "../utils/constant";
import Home from "../components/home";

const OpenRoute = () => {
  if (service === "mtnz") {
    return (
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/register" element={<Mtnz />} />
        <Route path="/login" element={<Mtnz />} />
        <Route path="*" element={<Navigate to="/register" />} />
      </Routes>
    );
  } else if (service === "mtnet") {
    return (
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/register" element={<Mtnet />} />
        <Route path="/login" element={<Mtnet />} />
        <Route path="*" element={<Navigate to="/register" />} />
      </Routes>
    );
  } else if (service === "mtnlb") {
    return (
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/register" element={<Mtnlb />} />
        <Route path="/login" element={<Mtnlb />} />
        <Route path="*" element={<Navigate to="/register" />} />
      </Routes>
    );
  }
};

export default OpenRoute;
